exports.components = {
  "component---src-pages-dashboard-js": () => import("./../../../src/pages/dashboard.js" /* webpackChunkName: "component---src-pages-dashboard-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-planillas-js": () => import("./../../../src/pages/planillas.js" /* webpackChunkName: "component---src-pages-planillas-js" */),
  "component---src-pages-platform-js": () => import("./../../../src/pages/platform.js" /* webpackChunkName: "component---src-pages-platform-js" */),
  "component---src-pages-vehicles-js": () => import("./../../../src/pages/vehicles.js" /* webpackChunkName: "component---src-pages-vehicles-js" */)
}

